<p-toast></p-toast>

<router-outlet></router-outlet>
<div class="loading-indicator" id="fullpage-loader">
  <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="6" animationDuration=".5s"></p-progressSpinner>
</div>
<app-dialog></app-dialog>
